import { request } from "@/utils/request";

/**
 * 获取菜单树形结构
 * @param {*} params 
 * @returns 
 */
export function getMenuTree(params) {
  return request({
    url: '/system/menu/menuTree',
    method: 'get',
    params
  })
}

/**
 * 保存菜单信息
 * @param {*} data 
 * @returns 
 */
export function saveMenu(data) {
  return request({
    url: '/system/menu/save',
    method: 'post',
    data
  })
}

/**
 * 删除菜单信息
 * @param {*} data 
 * @returns 
 */
export function removeMenu(data) {
  return request({
    url: '/system/menu/remove',
    method: 'post',
    data
  })
}

/**
 * 获取指定角色下的菜单列表
 * @param {*} roleId 
 * @returns 
 */
export function getMenusByRoleId(roleId) {
  return request({
    url: '/system/menu/getMenusByRoleId',
    method: 'get',
    params: { roleId }
  })
}